import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { debounce } from "lodash";
import axios from "axios";

import { addEntities } from "../../entities";
import {
  FETCH_GROUPS_FAILURE,
  FETCH_GROUPS_REQUEST,
  FETCH_GROUPS_SUCCESS
} from "../types";

const handleResponse = (
  response,
  dispatch,
  group,
  limit,
  ordering,
  filters
) => {
  const data = normalize(response.results, [group]);
  dispatch(addEntities(data.entities));
  dispatch(
    createAction(FETCH_GROUPS_SUCCESS)({
      items: data.result,
      count: response.count,
      next: response.next,
      previous: response.previous,
      ordering,
      limit,
      filters
    })
  );
  return response;
};

const debounced = debounce(
  async (dispatch, schema, api, limit, ordering, filters) => {
    dispatch(
      createAction(FETCH_GROUPS_REQUEST)({
        limit,
        filters,
        ordering
      })
    );
    const response = await api.groups.queryAdminGroups(
      limit,
      ordering,
      filters
    );
    handleResponse(response, dispatch, schema.group, limit, ordering, filters);
  },
  1000,
  { trailing: true }
);

export const next = (link, limit, ordering, filters) => async (
  dispatch,
  getState,
  { schema }
) => {
  try {
    dispatch(
      createAction(FETCH_GROUPS_REQUEST)({
        limit,
        ordering,
        filters
      })
    );

    const response = await axios.get(link);
    handleResponse(
      response.data,
      dispatch,
      schema.group,
      limit,
      ordering,
      filters
    );
  } catch (err) {
    dispatch(createAction(FETCH_GROUPS_FAILURE)(err));
    throw err;
  }
};

const fetchGroups = (limit, ordering, filters = {}) => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    await debounced(dispatch, schema, api, limit, ordering, filters);
  } catch (err) {
    dispatch(createAction(FETCH_GROUPS_FAILURE)(err));
    throw err;
  }
};

export default fetchGroups;
